<gs-generic-crud *ngIf="config" [configuration]="config" />
